import { render, staticRenderFns } from "./CardFaturamento.vue?vue&type=template&id=7dd78a38&"
import script from "./CardFaturamento.vue?vue&type=script&lang=js&"
export * from "./CardFaturamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports